<div class="card-block">
  <div class="title-container d-flex">
    <h3 (click)="onTitleCheckbox()" class="card-title max-lines">{{envelope.title}}</h3>
  </div>
  <!-- Segmento -->
  <div class="row m-0 mb-2 d-flex w-100 justify-content-start align-items-center">
    <span class="text-normal">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw fa-gray inline" [icon]="['fas', 'folder']">
      </fa-icon>{{ "envelope.sent.card.segment" | translate | titlecase }}:
    </span>
    <span class="text-field">
      {{ (envelope.segment?.name !== null && envelope.segment?.name !== undefined) ? envelope.segment?.name : ('none' | translate) }}
    </span>
  </div>
  <!-- Criado -->
  <div class="row m-0 mb-2 d-flex w-100 justify-content-start align-items-center">
    <span class="text-normal">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw fa-gray inline" [icon]="['fas', 'envelope-open-text']">
      </fa-icon>{{ "envelope.sent.card.created" | translate | titlecase }}:
    </span>
    <span class="text-field">
      {{ envelope.creationDate.datetime | date:getDateFormat() }}
    </span>
  </div>
  <!-- Documentos -->
  <div *ngIf="envelope.status === SentEnvelopeStatus.pending
    || envelope.status === SentEnvelopeStatus.onApproval || envelope.status === SentEnvelopeStatus.reproved || envelope.status === SentEnvelopeStatus.toFill"
    class="row m-0 mb-2 d-flex w-100 justify-content-start align-items-center">
    <span class="text-normal">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw fa-gray inline" [icon]="['far','file-alt']">
      </fa-icon>{{ "envelope.sent.card.documents" | translate | titlecase }}:
    </span>
    <span class="text-field">
      {{ envelope.totalFiles | number:'2.0' }}
    </span>
  </div>
  <!-- Modificado -->
  <div *ngIf="envelope.status === SentEnvelopeStatus.completed || envelope.status === SentEnvelopeStatus.expired"
    class="row m-0 mb-2 d-flex w-100 justify-content-start align-items-center">
    <span class="text-normal gray">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw inline" [icon]="['fas', 'edit']">
      </fa-icon>{{ "envelope.sent.card.modified" | translate | titlecase }}:
    </span>
    <div class="text-field gray">
      <span>{{ envelope.lastModifiedDate.datetime | date:getDateFormat() }}</span>
    </div>
  </div>
  <!-- Expiração -->
  <div *ngIf="envelope.status !== SentEnvelopeStatus.completed"
    class="row m-0 mb-2 d-flex w-100 justify-content-start align-items-center">
    <span class="text-normal"
      [ngClass]="{'gray': envelope.status === SentEnvelopeStatus.pending, 'red': envelope.status === SentEnvelopeStatus.expired}">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw inline" [icon]="['fas', 'hourglass-half']">
      </fa-icon>{{ "envelope.sent.card.expiration" | translate | titlecase }}:
    </span>
    <div class="text-field"
      [ngClass]="{'gray': envelope.status === SentEnvelopeStatus.pending, 'red': envelope.status === SentEnvelopeStatus.expired}">
      <span *ngIf="envelope.expiration">{{ envelope.expiration | date:getDateFormat() : 'envelope.listGrid.noExpiration'
        | translate | titlecase }}</span>
      <span *ngIf="!envelope.expiration">{{ 'envelope.listGrid.noExpiration' | translate | titlecase }}</span>
    </div>
  </div>
  <!-- Assinaturas -->
  <div class="row m-0 d-flex w-100 justify-content-start align-items-center">
    <span class="text-normal mb-2" *ngIf="envelope.status === SentEnvelopeStatus.pending">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw fa-gray inline" [icon]="['fas', 'signature']">
      </fa-icon>{{ "envelope.sent.card.signatures" | translate | titlecase }}:
    </span>
    <span class="text-normal mb-2"
      *ngIf="(envelope.status === SentEnvelopeStatus.onApproval || envelope.status === SentEnvelopeStatus.reproved)">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw fa-gray inline" [icon]="['fas', 'signature']">
      </fa-icon>{{ "envelope.sent.card.authorizers" | translate | titlecase }}:
    </span>
    <div class="text-field mb-2" *ngIf="envelope.status === SentEnvelopeStatus.pending">
      <span>&nbsp;{{ envelope.totalSignaturesCompleted }}/</span><span>{{ envelope.totalSignatures }}</span>
    </div>
    <div class="text-field mb-2"
      *ngIf="(envelope.status === SentEnvelopeStatus.onApproval || envelope.status === SentEnvelopeStatus.reproved)">
      <span>&nbsp;{{ envelope.totalAuthorizationsCompleted }}/</span><span>{{ envelope.totalAuthorizers }}</span>
    </div>
  </div>
  <!-- Conclusão -->
  <div *ngIf="envelope.status === SentEnvelopeStatus.completed"
    class="row m-0 mb-2 d-flex w-100 justify-content-start align-items-center">
    <span class="text-normal gray">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw inline" [icon]="['fas', 'check-circle']">
      </fa-icon>{{ "envelope.sent.card.conclution" | translate | titlecase }}:
    </span>
    <div class="text-field gray">
      <span>{{ envelope.conclutionDate.datetime | date:getDateFormat() }}</span>
    </div>
  </div>
  <!-- Exclusão -->
  <div *ngIf="envelope.status === SentEnvelopeStatus.deleted"
    class="row m-0 mb-2 d-flex w-100 justify-content-start align-items-center">
    <span class="text-normal gray">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw inline" [icon]="['fas', 'times-circle']">
      </fa-icon>{{ "envelope.sent.card.excluded" | translate | titlecase }}:
    </span>
    <div class="text-field gray">
      <span>{{ envelope.lastModifiedDate.datetime | date:getDateFormat() }}</span>
    </div>
  </div>
  <!-- Responsável -->
  <div *ngIf="envelope.status === SentEnvelopeStatus.toFill"
    class="text-field-max-line" [ngbTooltip]="envelope.responsibleName">
    <span class="text-normal">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw fa-gray inline" [icon]="['far', 'file-signature']">
      </fa-icon>{{ "envelope.sent.card.responsible" | translate | titlecase }}:
    </span>
    <span class="text-field ">
      {{ envelope.responsibleName }}
    </span>
  </div>
  <!-- Recusado -->
  <div *ngIf="envelope.status === SentEnvelopeStatus.rejected"
    class="row m-0 mb-2 d-flex w-100 justify-content-start align-items-center">
    <span class="text-normal">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw fa-gray inline" [icon]="['fas', 'times-circle']">
      </fa-icon>{{ "envelope.sent.card.rejected" | translate | titlecase }}:
    </span>
    <span class="text-field">
      {{ envelope.rejectedBy }}
    </span>
  </div>
  <!-- Data de recusa -->
  <div *ngIf="envelope.status === SentEnvelopeStatus.rejected"
    class="row m-0 mb-2 d-flex w-100 justify-content-start align-items-center">
    <span class="text-normal">
      <fa-icon style="padding-right: 1.5rem;" class="fa-fw fa-gray inline" [icon]="['fas', 'calendar-times']">
      </fa-icon>{{ "envelope.sent.card.dateRejected" | translate  }}:
    </span>
    <span class="text-field">
      {{ envelope.rejectedDate.datetime | date:getDateFormat() }}
    </span>
  </div>
</div>
